export default __webpack_public_path__ + "static/media/gothenburg_background_xl1.e2345802.jpg";